import { yupResolver } from "@hookform/resolvers/yup";
import { globalVariables } from "helper/globalVariables";
import * as Yup from "yup";

const mobileRegex =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
const emailRegex =
  /^([\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*)@((?:[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?\.)+[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?)$/;
// OWASP standard special characters for passwords
// Reference: https://owasp.org/www-community/password-special-characters
const passwordRegexSpecial =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{8,}$/;
const nameRegex = /^(?!\s)[A-Za-z][A-Za-z\s]*[\.]{0,1}[A-Za-z\s]*$/;
const firstSpace = /^(?!\s).*/;
const websiteRegex =
  /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

// const passwordRegex =
// 	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;

export const signupResolver = yupResolver(
  Yup.object().shape({
    name: Yup.string()
      .required(globalVariables.nameRequired)
      .matches(firstSpace, globalVariables.nameRequired),
    email: Yup.string()
      .required(globalVariables.emailRequired)
      .matches(emailRegex, globalVariables.invalidEmail),
    password: Yup.string()
      .required(globalVariables.passwordRequired)
      .matches(passwordRegexSpecial, globalVariables.mustHaveAtlease),
    confirmPassword: Yup.string()
      .required(globalVariables.passwordRequired)
      .oneOf([Yup.ref("password"), null], globalVariables.passwordNotMatch),
  })
);

export const loginResolver = yupResolver(
  Yup.object().shape({
    email: Yup.string()
      .required(globalVariables.emailRequired)
      .matches(
        /^([\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*)@((?:[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?\.)+[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?)$/,
        globalVariables.invalidEmail
      ),
    password: Yup.string()
      .min(8, globalVariables.mustHaveAtlease)
      .max(20)
      .required(globalVariables.passwordRequired),
  })
);

export const registerDogResolver = yupResolver(
  Yup.object().shape({
    callName: Yup.string().required(globalVariables.callNameRequired),
    breedMix: Yup.string().required(globalVariables.breedMixRequired),
  })
);

export const ResetPasswordResolver = yupResolver(
  Yup.object().shape({
    // email: Yup.string()
    //   .required("Email is Required")
    //   .matches(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, "Invalid Email"),

    password: Yup.string()
      .required(globalVariables.passwordRequired)
      .matches(passwordRegexSpecial, globalVariables.mustHaveAtlease),
    confirmPassword: Yup.string()
      .required(globalVariables.passwordRequired)
      .oneOf([Yup.ref("password"), null], globalVariables.passwordNotMatch),
  })
);

export const ForgotPasswordResolver = yupResolver(
  Yup.object().shape({
    email: Yup.string()
      .required("Email is Required")
      .matches(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        "Invalid Email"
      ),
  })
);
export const OTPResolver = yupResolver(
  Yup.object().shape({
    OTP: Yup.string()
      .required("OTP is Required")
      .matches(/^[0-9]{6}$/, "Invalid OTP"),
  })
);

export const registerMemberResolver = yupResolver(
  Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .max(15, "Name must be 15 characters or less")
      .required(globalVariables.firstNameRequired)
      .matches(nameRegex, globalVariables.firstNameRequired),
    lastName: Yup.string()
      .trim()
      .max(15, "Name must be 15 characters or less")
      .required(globalVariables.lastNameRequired)
      .matches(nameRegex, globalVariables.lastNameRequired),
    // email: Yup.string()
    //   .required(globalVariables.emailRequired)
    //   .matches(emailRegex, globalVariables.invalidEmail),
    location: Yup.string()
      .required(globalVariables.locationRequired)
      .matches(firstSpace, globalVariables.locationRequired),
    phoneNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.invalidPhoneNumber),
    emergencyContactName: Yup.string()
      .trim()
      // .matches(/^[^\s]+$/, "First Name must not contain spaces")
      .max(50, "Name must be 50 characters or less")
      .required(globalVariables.contactNameRequired)
      .matches(nameRegex, globalVariables.contactNameRequired),
      emergencyContactNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.contactNumberRequired)
      .test(
        "not-same-as-phone",
        "Emergency contact number must be different from your phone number",
        function (value) {
          const { phoneNumber } = this.parent;
          return value !== phoneNumber;
        }
      ),
    zip: Yup.string().required(globalVariables.zipRequired),
  })
);

export const registerEditMemberResolver = yupResolver(
  Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .max(15, "Name must be 15 characters or less")
      .required(globalVariables.firstNameRequired)
      .matches(nameRegex, globalVariables.firstNameRequired),
    lastName: Yup.string()
      .trim()
      .max(15, "Name must be 15 characters or less")
      .required(globalVariables.lastNameRequired)
      .matches(nameRegex, globalVariables.lastNameRequired),
    email: Yup.string()
      .required(globalVariables.emailRequired)
      .matches(emailRegex, globalVariables.invalidEmail),
    location: Yup.string()
      .required(globalVariables.locationRequired)
      .matches(firstSpace, globalVariables.locationRequired),
    phoneNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.invalidPhoneNumber),
    emergencyContactName: Yup.string()
      .trim()
      // .matches(/^[^\s]+$/, "First Name must not contain spaces")
      .max(50, "Name must be 50 characters or less")
      .required(globalVariables.contactNameRequired)
      .matches(nameRegex, globalVariables.contactNameRequired),
    emergencyContactNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.contactNumberRequired),
    zip: Yup.string().required(globalVariables.zipRequired),
  })
);

export const becomeAJudgeResolver = yupResolver(
  Yup.object().shape({
    phoneNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.invalidPhoneNumber),
    timeZone: Yup.string().required(globalVariables.selectTimeZone),
    distance: Yup.string().required(globalVariables.enterValidDistance),
    address: Yup.string().required(globalVariables.enterValidAddress),
  })
);

export const hostDetailsResolver = yupResolver(
  Yup.object().shape({
    hostName: Yup.string()
      .trim()
      .max(30, "Name must be 30 characters or less")
      .required(globalVariables.hostNameRequired)
      .matches(firstSpace, globalVariables.hostNameRequired),

    contactAddress: Yup.string()
      .required(globalVariables.contactAddressRequired)
      .matches(firstSpace, globalVariables.contactAddressRequired),

    hostPaypalEmail: Yup.string()
      .required("Payment email is required as a fallback payment method")
      .matches(emailRegex, globalVariables.invalidEmail),
    paypalPaymentLink: Yup.string()
      .url("Please enter a valid URL (e.g., https://paypal.me/yourname or https://buy.stripe.com/...)")
      .nullable()
      .test('is-https', 'Payment link must start with https:// for security', value => {
        if (!value) return true; // Allow empty
        return value.startsWith('https://') || value.startsWith('http://');
      }),
    trialSecretaryName: Yup.string()
      .required(globalVariables.trialSecretaryNameRequired)
      .matches(firstSpace, globalVariables.trialSecretaryNameRequired),
    trialSecretaryEmailAddress: Yup.string()
      .required(globalVariables.trialSecretaryEmailAddressRequired)
      .matches(emailRegex, globalVariables.invalidEmail),
    zip: Yup.string().required(globalVariables.zipRequired),
  })
);

export const trialDetailsResolver = yupResolver(
  Yup.object().shape({
    trialName: Yup.string()
      .trim()
      .max(30, "Name must be 30 characters or less")
      .required(globalVariables.trialNameRequired)
      .matches(firstSpace, globalVariables.trialNameRequired),
    trialLocationName: Yup.string()
      .required(globalVariables.location)
      .matches(firstSpace, globalVariables.location),
    trialLocationAddress: Yup.string()
      .required(globalVariables.trialLocationAddressRequired)
      .matches(firstSpace, globalVariables.trialLocationAddressRequired),
    zip: Yup.string().required(globalVariables.zipRequired),
    timeZone: Yup.string().required(globalVariables.timeZoneRequired),
    trialDate: Yup.date().required(globalVariables.pleaseSelectDate),
    closeDate: Yup.date()
      .required(globalVariables.pleaseSelectDate)
      .test(
        "valid-trial-close",
        "Close date cannot be earlier than the Open date.",
        function (value) {
          const { openDate } = this.parent;
          return value >= openDate;
        }
      )
      .test(
        "minimum-gap",
        "Close date must be at least 3 days after the Open date.",
        function (value) {
          const { openDate } = this.parent;
          if (!openDate || !value) return true;
          const minCloseDate = new Date(openDate);
          minCloseDate.setDate(minCloseDate.getDate() + 3);
          return value >= minCloseDate;
        }
      )
      .test(
        "valid-trial-minus-12",
        "The close date should be at least 12 days before the trial date.",
        function (value) {
          const { trialDate } = this.parent;
          if (!trialDate || !value) return true;
          const trialDateMinus12 = new Date(trialDate);
          trialDateMinus12.setDate(trialDateMinus12.getDate() - 12);
          return value < trialDateMinus12;
        }
      ),
    openDate: Yup.date()
      .required(globalVariables.pleaseSelectDate)
      .test(
        "valid-trial-close",
        "Open date cannot be after the trial date.",
        function (value) {
          const { trialDate } = this.parent;
          if (!trialDate || !value) return true;
          return value <= trialDate;
        }
      )
      .test(
        "valid-open-date",
        "The Open date should be at least 15 days before the trial date.",
        function (value) {
          const { trialDate } = this.parent;
          if (!trialDate || !value) return true;
          const trialDateMinus15 = new Date(trialDate);
          trialDateMinus15.setDate(trialDateMinus15.getDate() - 15);
          return value <= trialDateMinus15;
        }
      ),
    cutoffDate: Yup.date()
      .required("Please select a Cutoff Date")
      .test(
        "cutoff-after-close",
        "Cutoff date must be after the Close date.",
        function (value) {
          const { closeDate } = this.parent;
          if (!closeDate || !value) return true;
          return value > closeDate;
        }
      )
      .test(
        "cutoff-before-trial",
        "Cutoff date must be before the Trial date.",
        function (value) {
          const { trialDate } = this.parent;
          if (!trialDate || !value) return true;
          return value < trialDate;
        }
      ),
  })
);


export const searchDetailResolver = yupResolver(
  Yup.object().shape({
    searchName: Yup.string()
      .required(globalVariables.searchNameRequired)
      .matches(firstSpace, globalVariables.searchNameRequired),
    entryFee: Yup.number()
      .positive()
      .typeError(globalVariables.entryFeeRequired)
      .positive(globalVariables.entryFeeRequired)
      .required(globalVariables.entryFeeRequired),
    maxEntries: Yup.number()
      .positive()
      .typeError(globalVariables.maxNumberEntriesRequired)
      .positive(globalVariables.maxNumberEntriesRequired)
      .required(globalVariables.maxNumberEntriesRequired),
  })
);

export const dogProfileResolver = yupResolver(
  Yup.object().shape({
    dogName: Yup.string().required(globalVariables.dogNameError),
    // ownerName: Yup.string().required(globalVariables.ownerNameError),
    // breedMix: Yup.string().required(globalVariables.breedMixError),
  })
);

export const addNoteResolver = yupResolver(
  Yup.object().shape({
    note: Yup.string().required(globalVariables.noteError),
  })
);

export const hostProfileResolver = yupResolver(
  Yup.object().shape(
    {
      firstName: Yup.string()
        .trim()
        .max(15, "Name must be 15 characters or less")
        .matches(nameRegex, globalVariables.inputNotMeet),
      lastName: Yup.string()
        .trim()
        .max(15, "Name must be 15 characters or less")
        .matches(nameRegex, globalVariables.inputNotMeet),
      address: Yup.string().matches(firstSpace, globalVariables.inputNotMeet),
      email: Yup.string().matches(emailRegex, globalVariables.invalidEmail),
      phoneNumber: Yup.string().matches(
        mobileRegex,
        globalVariables.invalidPhoneNumber
      ),
      website: Yup.string().when("website", {
        is: (website) => website,
        then: () =>
          Yup.string().matches(websiteRegex, globalVariables.inputNotMeet),
      }),
    },
    [["website", "website"]]
  )
);

export const judgeBasicDetailsResolver = yupResolver(
  Yup.object().shape({
    name: Yup.string()
      .trim()
      .max(30, "Name must be 25 characters or less")
      .required(globalVariables.enterNameProceed)
      .matches(firstSpace, globalVariables.enterNameProceed),
    phoneNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.invalidPhoneNumber),
    distance: Yup.number()
      .typeError(globalVariables.enterValidDistance)
      .positive(globalVariables.enterValidDistance)
      .required(globalVariables.enterValidDistance),
    address: Yup.string().required(globalVariables.enterValidAddress),
  })
);

export const judgeProfileResolver = yupResolver(
  Yup.object().shape({
    name: Yup.string()
      .trim()
      .max(30, "Name must be 25 characters or less")
      .required(globalVariables.enterNameProceed)
      .matches(firstSpace, globalVariables.enterNameProceed),
    email: Yup.string()
      .required(globalVariables.emailRequired)
      .matches(emailRegex, globalVariables.invalidEmail),
    phoneNumber: Yup.string()
      .required(globalVariables.phoneRequired)
      .matches(mobileRegex, globalVariables.invalidPhoneNumber),
    address: Yup.string()
      .required(globalVariables.enterValidAddress)
      .matches(firstSpace, globalVariables.enterValidAddress),
    // distance field removed - now managed as state variable with dropdown
    zip: Yup.string().required(globalVariables.zipRequired),
  })
);
